import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { URLS } from '@shared/constants/api-request.urls';
import { map, of, tap } from 'rxjs';
import { VISIBILITY_KEYS, VisibilityKey } from '@shared/constants/visibility-keys.constants';
import { LanguageService } from '@core/services/language/language.service';

@Injectable({
  providedIn: 'root',
})
export class SectorsService {
  constructor(private http: HttpClient) {}
  private languageService = inject(LanguageService);
  private sectorsListCacheByLanguage = new Map<string, any>();

  getSectors(pageNumber?: number, pageSize?: number, visibility?: VisibilityKey | undefined) {
    let params = new HttpParams().set('mode', 'details');
    if (pageNumber) {
      params = params.set('pageNumber', pageNumber);
    }
    if (pageSize) {
      params = params.set('pageSize', pageSize);
    }
    if (visibility) {
      params = params.set('visibility', visibility);
    }

    return this.http.get<any>(`${URLS.SECTOR}`, { params }).pipe(map((res) => res.data));
  }

  getSectorCompanies(
    pageNumber: number,
    pageSize: number,
    sectorId?: string,
    visibility: VisibilityKey = VISIBILITY_KEYS.COMPANY_TABLE
  ) {
    let params = new HttpParams();
    params = params.set('pageSize', pageSize);
    params = params.set('pageNumber', pageNumber);
    if (sectorId) {
      params = params.set('filter', `sectorId="${sectorId}"`);
    }
    params = params.set('visibility', visibility);

    return this.http.get<any>(`${URLS.STOCK}`, { params }).pipe(map((res) => res.data));
  }

  getSectorsList() {
    const lang = this.languageService.getCurrentLanguage() || 'ar';
    if (this.sectorsListCacheByLanguage.has(lang)) {
      return of(this.sectorsListCacheByLanguage.get(lang));
    }
    return this.http.get<any>(`${URLS.SECTOR}/lookup`).pipe(
      map((res) => res.data),
      tap((data) => this.sectorsListCacheByLanguage.set(lang, data))
    );
  }
}
